import { Button, createStyles, Grid, Theme, Typography, withStyles } from "@material-ui/core";
import React, { PureComponent } from "react";
import { MyPATTextField, MyPATDialog, MyPATIconButton } from "../../../common";

import { CloseOutlined as CloseIcon } from "@material-ui/icons";

const styles = (theme: Theme) =>
  createStyles({
    formContainer: {
      minWidth: "500px",
      width: "100%",
    },
    actionButton: {
      marginTop: "15px",
    },
    dialogT: {
      textAlign: "center",
      "& h5": {
        textAlign: "center",
      },
    },
    m0:{
      '&> div':{
      marginBottom: 0,
    },
  }
});

interface Props {
  onClose: () => void;
  onSave: (templateName: string) => void;
  classes?: any;
}

interface State {
  templateName: string;
}

class TestTemplateNamePopup extends PureComponent<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      templateName: ""
    };
  }
 
  handleTemplateNameChange = (e: any) => {
    this.setState({
      templateName: e.target.value,
    });
  };
  handleSubmit = (e: any) => {
    e.preventDefault();
    this.props.onSave(this.state.templateName);
    this.props.onClose();
  }
  render() {
    const { classes, onClose } = this.props;
    return (
      <MyPATDialog
        dialogOpen={true}
        onDialogClose={onClose}
        onDialogBack={onClose}
        customButtonVariant="withoutBorderCloseIcon"
        variantHeader="centertHeader"
        customDialogTitle={
          <Grid
            container
            justify="center"
            alignItems="center"
            className={classes.dialogT}
          >
            <Grid item xs={11}>
              <Typography variant="h5" noWrap>
                Test Template
              </Typography>
            </Grid>
            <Grid item xs={1} className={classes.dialogCloseContainer}>
              <MyPATIconButton
                buttonVariant="withoutBorderCloseIcon"
                onClick={onClose}
              >
                <CloseIcon />
              </MyPATIconButton>
            </Grid>
          </Grid>
        }
      >
        <form
          onSubmit={this.handleSubmit}
          className={classes.formContainer}
        >
          <Grid container alignItems="center">
            <Grid item xs={4}>
              {/* <Grid container alignItems="flex-start"> */}
              {/* <Typography variant="h5" noWrap>
                Test Template
              </Typography> */}
              {/* </Grid> */}
              {/* <MyPATIconButton
              buttonVariant="withoutBorderCloseIcon"
              onClick={onClose}
            >
              <CloseIcon />
            </MyPATIconButton> */}
              <label>Enter Template Name</label>
            </Grid>
            <Grid item xs={8}>
              <Grid className={classes.m0}>
             
                  <MyPATTextField
                    inputId="TemplateName"
                    name="TemplateName"
                    fullWidthControl
                    placeholder="Enter Template Name"
                    onChange={this.handleTemplateNameChange}
                    inputProps={{
                      required: true,
                      minLength: 1,
                    }}
                  />
                
              </Grid>
            </Grid>
          </Grid>

          <Grid
            container
            justify="center"
            alignItems="center"
            className={classes.actionButton}
          >
            <Button
              variant="contained"
              classes={{ root: classes.saveBtn }}
              // onClick={()=>this.saveTestTemplate.bind(this)}
              disabled={this.state.templateName === ''}
              type="submit"
              color="primary"
            >
              Save
            </Button>
          </Grid>
        </form>
      </MyPATDialog>
    );
  }
}

// export default TestTemplateNamePopup;
//@ts-ignore
export default withStyles(styles)(TestTemplateNamePopup);